import React from 'react';
import ColorPicker from '../ui/ColorPicker';

const FooterBlockEditor = ({ block, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate(block.id, {
      config: {
        ...block.config,
        [field]: value,
      },
    });
  };

  const handleStyleChange = (field, value) => {
    onUpdate(block.id, {
      styles: {
        ...block.styles,
        [field]: value,
      },
    });
  };

  const handleAddSocialLink = () => {
    const newLink = {
      platform: 'twitter',
      url: '',
      label: 'Twitter',
    };
    handleChange('socialLinks', [...(block.config.socialLinks || []), newLink]);
  };

  const handleUpdateSocialLink = (index, field, value) => {
    const updatedLinks = [...(block.config.socialLinks || [])];
    updatedLinks[index] = { ...updatedLinks[index], [field]: value };
    handleChange('socialLinks', updatedLinks);
  };

  const handleRemoveSocialLink = (index) => {
    const updatedLinks = (block.config.socialLinks || []).filter((_, i) => i !== index);
    handleChange('socialLinks', updatedLinks);
  };

  return (
    <div>
      <div className="editor-section">
        <h4 className="editor-section-title">Footer Content</h4>

        <div className="editor-field">
          <label>Company Name</label>
          <input
            type="text"
            value={block.config.companyName || ''}
            onChange={(e) => handleChange('companyName', e.target.value)}
            placeholder="KNKT"
          />
        </div>

        <div className="editor-field">
          <label>Address</label>
          <textarea
            value={block.config.address || ''}
            onChange={(e) => handleChange('address', e.target.value)}
            placeholder="123 Music Lane, Los Angeles, CA 90001"
            rows={3}
          />
        </div>

        <div className="editor-field" style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <input
              type="checkbox"
              checked={block.config.showUnsubscribe !== false}
              onChange={(e) => handleChange('showUnsubscribe', e.target.checked)}
            />
            Show Unsubscribe Link
          </label>
        </div>

        <div className="editor-field">
          <label>Social Links</label>
          {(block.config.socialLinks || []).map((link, index) => (
            <div key={index} style={{ marginBottom: '1rem', padding: '1rem', border: '1px solid #333', borderRadius: '0.375rem' }}>
              <div className="editor-field">
                <label>Platform</label>
                <select
                  value={link.platform || 'twitter'}
                  onChange={(e) => handleUpdateSocialLink(index, 'platform', e.target.value)}
                >
                  <option value="twitter">Twitter</option>
                  <option value="instagram">Instagram</option>
                  <option value="facebook">Facebook</option>
                  <option value="youtube">YouTube</option>
                  <option value="spotify">Spotify</option>
                  <option value="soundcloud">SoundCloud</option>
                  <option value="tiktok">TikTok</option>
                  <option value="website">Website</option>
                </select>
              </div>
              <div className="editor-field">
                <label>URL</label>
                <input
                  type="url"
                  value={link.url || ''}
                  onChange={(e) => handleUpdateSocialLink(index, 'url', e.target.value)}
                  placeholder="https://..."
                />
              </div>
              <button
                type="button"
                onClick={() => handleRemoveSocialLink(index)}
                style={{ color: '#ff4444', fontSize: '0.875rem', marginTop: '0.5rem' }}
              >
                Remove
              </button>
            </div>
          ))}
          <button
            type="button"
            className="btn-secondary"
            onClick={handleAddSocialLink}
            style={{ width: '100%', marginTop: '0.5rem' }}
          >
            Add Social Link
          </button>
        </div>
      </div>

      <div className="editor-section">
        <h4 className="editor-section-title">Styling</h4>

        <div className="editor-field">
          <ColorPicker
            label="Background Color"
            color={block.styles.backgroundColor || '#1a1a1a'}
            onChange={(value) => handleStyleChange('backgroundColor', value)}
          />
        </div>

        <div className="editor-field">
          <label>Text Alignment</label>
          <select
            value={block.styles.textAlign || 'center'}
            onChange={(e) => handleStyleChange('textAlign', e.target.value)}
          >
            <option value="left">Left</option>
            <option value="center">Center</option>
            <option value="right">Right</option>
          </select>
        </div>

        <div className="editor-field">
          <label>Padding (px)</label>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
            <input
              type="number"
              value={block.styles.padding?.top || 20}
              onChange={(e) => handleStyleChange('padding', { ...block.styles.padding, top: parseInt(e.target.value) })}
              placeholder="Top"
              min="0"
            />
            <input
              type="number"
              value={block.styles.padding?.right || 20}
              onChange={(e) => handleStyleChange('padding', { ...block.styles.padding, right: parseInt(e.target.value) })}
              placeholder="Right"
              min="0"
            />
            <input
              type="number"
              value={block.styles.padding?.bottom || 20}
              onChange={(e) => handleStyleChange('padding', { ...block.styles.padding, bottom: parseInt(e.target.value) })}
              placeholder="Bottom"
              min="0"
            />
            <input
              type="number"
              value={block.styles.padding?.left || 20}
              onChange={(e) => handleStyleChange('padding', { ...block.styles.padding, left: parseInt(e.target.value) })}
              placeholder="Left"
              min="0"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterBlockEditor;
